/*Global*/ 
import logo from '../assets/Logo/Logo.png';

/*Home*/
import home1 from '../assets/Home/Home-1.jpg'; 
import home2 from '../assets/Home/Home-2.jpg';
import home3 from '../assets/Home/Home-3.jpg'; 

/*Partners*/
import partner1 from '../assets/Partners/Partner-1.png';
import partner2 from '../assets/Partners/Partner-2.png';
import partner3 from '../assets/Partners/Partner-3.png';
import partner4 from '../assets/Partners/Partner-4.png';
import partner5 from '../assets/Partners/Partner-5.png';
import partner6 from '../assets/Partners/Partner-6.png';

/*About*/
import about from '../assets/About/About.jpg';

/*Testimonials*/
import testimonial1 from '../assets/Testimonials/Pic-1.jpg';
import testimonial2 from '../assets/Testimonials/Pic-2.jpg';
import testimonial3 from '../assets/Testimonials/Pic-3.jpg';
import testimonial4 from '../assets/Testimonials/Pic-4.jpg';

/*Team*/
import team1 from '../assets/Team/Team-1.jpg';
import team2 from '../assets/Team/Team-2.jpg';
import team3 from '../assets/Team/Team-3.jpg';
import team4 from '../assets/Team/Team-4.jpg';

/*FAQs*/
import FAQs from '../assets/FAQs/FAQs.jpg';

/*Gallery*/
import gallery1 from '../assets/Gallery/Gallery-1.jpg';
import gallery2 from '../assets/Gallery/Gallery-2.jpg';
import gallery3 from '../assets/Gallery/Gallery-3.jpg';
import gallery4 from '../assets/Gallery/Gallery-4.jpg';
import gallery5 from '../assets/Gallery/Gallery-5.jpg';
import gallery6 from '../assets/Gallery/Gallery-6.jpg';
import gallery7 from '../assets/Gallery/Gallery-7.jpg';
import gallery8 from '../assets/Gallery/Gallery-8.jpg';
import gallery9 from '../assets/Gallery/Gallery-9.jpg';
import gallery10 from '../assets/Gallery/Gallery-10.jpg';

/*Service*/
import service1 from '../assets/Service/Services/Service-1.jpg';
import service1Gallery1 from '../assets/Service/Gallery/1.jpg';
import service1Gallery2 from '../assets/Service/Gallery/2.jpg';

import service2 from '../assets/Service/Services/Service-2.jpg';
import service2Gallery1 from '../assets/Service/Gallery/1.jpg';
import service2Gallery2 from '../assets/Service/Gallery/2.jpg';

import service3 from '../assets/Service/Services/Service-3.jpg';
import service3Gallery1 from '../assets/Service/Gallery/1.jpg';
import service3Gallery2 from '../assets/Service/Gallery/2.jpg';

import service4 from '../assets/Service/Services/Service-4.jpg';
import service4Gallery1 from '../assets/Service/Gallery/1.jpg';
import service4Gallery2 from '../assets/Service/Gallery/2.jpg';

import service5 from '../assets/Service/Services/Service-5.jpg';
import service5Gallery1 from '../assets/Service/Gallery/1.jpg';
import service5Gallery2 from '../assets/Service/Gallery/2.jpg';

import service6 from '../assets/Service/Services/Service-6.jpg';
import service6Gallery1 from '../assets/Service/Gallery/1.jpg';
import service6Gallery2 from '../assets/Service/Gallery/2.jpg';

/*Portfolio*/
import portfolio1 from '../assets/Portfolio/Portfolio/Portfolio-1.jpg';
import portfolio1Gallery1 from '../assets/Portfolio/Portfolio-Gallery/1.jpg';
import portfolio1Gallery2 from '../assets/Portfolio/Portfolio-Gallery/2.jpg';
import portfolio1Gallery3 from '../assets/Portfolio/Portfolio-Gallery/3.jpg';
import portfolio1Gallery4 from '../assets/Portfolio/Portfolio-Gallery/4.jpg';
import portfolio1Gallery5 from '../assets/Portfolio/Portfolio-Gallery/5.jpg';
import portfolio1Gallery6 from '../assets/Portfolio/Portfolio-Gallery/6.jpg';

import portfolio2 from '../assets/Portfolio/Portfolio/Portfolio-2.jpg';
import portfolio2Gallery1 from '../assets/Portfolio/Portfolio-Gallery/1.jpg';
import portfolio2Gallery2 from '../assets/Portfolio/Portfolio-Gallery/2.jpg';
import portfolio2Gallery3 from '../assets/Portfolio/Portfolio-Gallery/3.jpg';
import portfolio2Gallery4 from '../assets/Portfolio/Portfolio-Gallery/4.jpg';
import portfolio2Gallery5 from '../assets/Portfolio/Portfolio-Gallery/5.jpg';
import portfolio2Gallery6 from '../assets/Portfolio/Portfolio-Gallery/6.jpg';

import portfolio3 from '../assets/Portfolio/Portfolio/Portfolio-3.jpg';
import portfolio3Gallery1 from '../assets/Portfolio/Portfolio-Gallery/1.jpg';
import portfolio3Gallery2 from '../assets/Portfolio/Portfolio-Gallery/2.jpg';
import portfolio3Gallery3 from '../assets/Portfolio/Portfolio-Gallery/3.jpg';
import portfolio3Gallery4 from '../assets/Portfolio/Portfolio-Gallery/4.jpg';
import portfolio3Gallery5 from '../assets/Portfolio/Portfolio-Gallery/5.jpg';
import portfolio3Gallery6 from '../assets/Portfolio/Portfolio-Gallery/6.jpg';

import portfolio4 from '../assets/Portfolio/Portfolio/Portfolio-4.jpg';
import portfolio4Gallery1 from '../assets/Portfolio/Portfolio-Gallery/1.jpg';
import portfolio4Gallery2 from '../assets/Portfolio/Portfolio-Gallery/2.jpg';
import portfolio4Gallery3 from '../assets/Portfolio/Portfolio-Gallery/3.jpg';
import portfolio4Gallery4 from '../assets/Portfolio/Portfolio-Gallery/4.jpg';
import portfolio4Gallery5 from '../assets/Portfolio/Portfolio-Gallery/5.jpg';
import portfolio4Gallery6 from '../assets/Portfolio/Portfolio-Gallery/6.jpg';

import portfolio5 from '../assets/Portfolio/Portfolio/Portfolio-5.jpg';
import portfolio5Gallery1 from '../assets/Portfolio/Portfolio-Gallery/1.jpg';
import portfolio5Gallery2 from '../assets/Portfolio/Portfolio-Gallery/2.jpg';
import portfolio5Gallery3 from '../assets/Portfolio/Portfolio-Gallery/3.jpg';
import portfolio5Gallery4 from '../assets/Portfolio/Portfolio-Gallery/4.jpg';
import portfolio5Gallery5 from '../assets/Portfolio/Portfolio-Gallery/5.jpg';
import portfolio5Gallery6 from '../assets/Portfolio/Portfolio-Gallery/6.jpg';

import portfolio6 from '../assets/Portfolio/Portfolio/Portfolio-6.jpg';
import portfolio6Gallery1 from '../assets/Portfolio/Portfolio-Gallery/1.jpg';
import portfolio6Gallery2 from '../assets/Portfolio/Portfolio-Gallery/2.jpg';
import portfolio6Gallery3 from '../assets/Portfolio/Portfolio-Gallery/3.jpg';
import portfolio6Gallery4 from '../assets/Portfolio/Portfolio-Gallery/4.jpg';
import portfolio6Gallery5 from '../assets/Portfolio/Portfolio-Gallery/5.jpg';
import portfolio6Gallery6 from '../assets/Portfolio/Portfolio-Gallery/6.jpg';


/*Blogs*/
import blog1 from '../assets/Blog/Blogs/Blog-1.jpg';
import blog1Gallery1 from '../assets/Blog/Gallery/1.jpg';
import blog1Gallery2 from '../assets/Blog/Gallery/2.jpg';
import blog1Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog1Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog1Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog2 from '../assets/Blog/Blogs/Blog-2.jpg';
import blog2Gallery1 from '../assets/Blog/Gallery/1.jpg';
import blog2Gallery2 from '../assets/Blog/Gallery/2.jpg';
import blog2Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog2Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog2Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog3 from '../assets/Blog/Blogs/Blog-3.jpg';
import blog3Gallery1 from '../assets/Blog/Gallery/1.jpg';
import blog3Gallery2 from '../assets/Blog/Gallery/2.jpg';
import blog3Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog3Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog3Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog4 from '../assets/Blog/Blogs/Blog-4.jpg';
import blog4Gallery1 from '../assets/Blog/Gallery/1.jpg';
import blog4Gallery2 from '../assets/Blog/Gallery/2.jpg';
import blog4Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog4Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog4Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog5 from '../assets/Blog/Blogs/Blog-5.jpg';
import blog5Gallery1 from '../assets/Blog/Gallery/1.jpg';
import blog5Gallery2 from '../assets/Blog/Gallery/2.jpg';
import blog5Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog5Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog5Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog6 from '../assets/Blog/Blogs/Blog-6.jpg';
import blog6Gallery1 from '../assets/Blog/Gallery/1.jpg';
import blog6Gallery2 from '../assets/Blog/Gallery/2.jpg';
import blog6Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog6Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog6Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog7 from '../assets/Blog/Blogs/Blog-7.jpg';
import blog7Gallery1 from '../assets/Blog/Gallery/1.jpg';
import blog7Gallery2 from '../assets/Blog/Gallery/2.jpg';
import blog7Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog7Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog7Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog8 from '../assets/Blog/Blogs/Blog-8.jpg';
import blog8Gallery1 from '../assets/Blog/Gallery/1.jpg';
import blog8Gallery2 from '../assets/Blog/Gallery/2.jpg';
import blog8Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog8Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog8Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog9 from '../assets/Blog/Blogs/Blog-9.jpg';
import blog9Gallery1 from '../assets/Blog/Gallery/1.jpg';
import blog9Gallery2 from '../assets/Blog/Gallery/2.jpg';
import blog9Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog9Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog9Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog10 from '../assets/Blog/Blogs/Blog-10.jpg';
import blog10Gallery1 from '../assets/Blog/Gallery/1.jpg';
import blog10Gallery2 from '../assets/Blog/Gallery/2.jpg';
import blog10Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog10Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog10Comment3 from '../assets/Blog/Comments/Pic-3.jpg';


/*Cars*/ 
import car1Gallery1 from '../assets/Car/Cars/Car-1.jpg';
import car1Gallery2 from '../assets/Car/Cars/Car-2.jpg';
import car1Gallery3 from '../assets/Car/Cars/Car-3.jpg';
import car1Gallery4 from '../assets/Car/Cars/Car-4.jpg';
import car1Review1 from '../assets/Car/Reviews/Pic-1.jpg';
import car1Review2 from '../assets/Car/Reviews/Pic-2.jpg';

import car2Gallery1 from '../assets/Car/Cars/Car-2.jpg';
import car2Gallery2 from '../assets/Car/Cars/Car-3.jpg';
import car2Gallery3 from '../assets/Car/Cars/Car-4.jpg';
import car2Gallery4 from '../assets/Car/Cars/Car-5.jpg';
import car2Review1 from '../assets/Car/Reviews/Pic-1.jpg';
import car2Review2 from '../assets/Car/Reviews/Pic-2.jpg';

import car3Gallery1 from '../assets/Car/Cars/Car-3.jpg';
import car3Gallery2 from '../assets/Car/Cars/Car-4.jpg';
import car3Gallery3 from '../assets/Car/Cars/Car-5.jpg';
import car3Gallery4 from '../assets/Car/Cars/Car-6.jpg';
import car3Review1 from '../assets/Car/Reviews/Pic-1.jpg';
import car3Review2 from '../assets/Car/Reviews/Pic-2.jpg';

import car4Gallery1 from '../assets/Car/Cars/Car-4.jpg';
import car4Gallery2 from '../assets/Car/Cars/Car-5.jpg';
import car4Gallery3 from '../assets/Car/Cars/Car-6.jpg';
import car4Gallery4 from '../assets/Car/Cars/Car-7.jpg';
import car4Review1 from '../assets/Car/Reviews/Pic-1.jpg';
import car4Review2 from '../assets/Car/Reviews/Pic-2.jpg';

import car5Gallery1 from '../assets/Car/Cars/Car-5.jpg';
import car5Gallery2 from '../assets/Car/Cars/Car-6.jpg';
import car5Gallery3 from '../assets/Car/Cars/Car-7.jpg';
import car5Gallery4 from '../assets/Car/Cars/Car-8.jpg';
import car5Review1 from '../assets/Car/Reviews/Pic-1.jpg';
import car5Review2 from '../assets/Car/Reviews/Pic-2.jpg';

import car6Gallery1 from '../assets/Car/Cars/Car-6.jpg';
import car6Gallery2 from '../assets/Car/Cars/Car-7.jpg';
import car6Gallery3 from '../assets/Car/Cars/Car-8.jpg';
import car6Gallery4 from '../assets/Car/Cars/Car-9.jpg';
import car6Review1 from '../assets/Car/Reviews/Pic-1.jpg';
import car6Review2 from '../assets/Car/Reviews/Pic-2.jpg';

import car7Gallery1 from '../assets/Car/Cars/Car-7.jpg';
import car7Gallery2 from '../assets/Car/Cars/Car-8.jpg';
import car7Gallery3 from '../assets/Car/Cars/Car-9.jpg';
import car7Gallery4 from '../assets/Car/Cars/Car-10.jpg';
import car7Review1 from '../assets/Car/Reviews/Pic-1.jpg';
import car7Review2 from '../assets/Car/Reviews/Pic-2.jpg';

import car8Gallery1 from '../assets/Car/Cars/Car-8.jpg';
import car8Gallery2 from '../assets/Car/Cars/Car-9.jpg';
import car8Gallery3 from '../assets/Car/Cars/Car-10.jpg';
import car8Gallery4 from '../assets/Car/Cars/Car-11.jpg';
import car8Review1 from '../assets/Car/Reviews/Pic-1.jpg';
import car8Review2 from '../assets/Car/Reviews/Pic-2.jpg';

import car9Gallery1 from '../assets/Car/Cars/Car-9.jpg';
import car9Gallery2 from '../assets/Car/Cars/Car-10.jpg';
import car9Gallery3 from '../assets/Car/Cars/Car-11.jpg';
import car9Gallery4 from '../assets/Car/Cars/Car-12.jpg';
import car9Review1 from '../assets/Car/Reviews/Pic-1.jpg';
import car9Review2 from '../assets/Car/Reviews/Pic-2.jpg';

import car10Gallery1 from '../assets/Car/Cars/Car-10.jpg';
import car10Gallery2 from '../assets/Car/Cars/Car-11.jpg';
import car10Gallery3 from '../assets/Car/Cars/Car-12.jpg';
import car10Gallery4 from '../assets/Car/Cars/Car-13.jpg';
import car10Review1 from '../assets/Car/Reviews/Pic-1.jpg';
import car10Review2 from '../assets/Car/Reviews/Pic-2.jpg';

import car11Gallery1 from '../assets/Car/Cars/Car-11.jpg';
import car11Gallery2 from '../assets/Car/Cars/Car-12.jpg';
import car11Gallery3 from '../assets/Car/Cars/Car-13.jpg';
import car11Gallery4 from '../assets/Car/Cars/Car-14.jpg';
import car11Review1 from '../assets/Car/Reviews/Pic-1.jpg';
import car11Review2 from '../assets/Car/Reviews/Pic-2.jpg';

import car12Gallery1 from '../assets/Car/Cars/Car-12.jpg';
import car12Gallery2 from '../assets/Car/Cars/Car-13.jpg';
import car12Gallery3 from '../assets/Car/Cars/Car-14.jpg';
import car12Gallery4 from '../assets/Car/Cars/Car-15.jpg';
import car12Review1 from '../assets/Car/Reviews/Pic-1.jpg';
import car12Review2 from '../assets/Car/Reviews/Pic-2.jpg';

import car13Gallery1 from '../assets/Car/Cars/Car-13.jpg';
import car13Gallery2 from '../assets/Car/Cars/Car-14.jpg';
import car13Gallery3 from '../assets/Car/Cars/Car-15.jpg';
import car13Gallery4 from '../assets/Car/Cars/Car-16.jpg';
import car13Review1 from '../assets/Car/Reviews/Pic-1.jpg';
import car13Review2 from '../assets/Car/Reviews/Pic-2.jpg';

import car14Gallery1 from '../assets/Car/Cars/Car-14.jpg';
import car14Gallery2 from '../assets/Car/Cars/Car-15.jpg';
import car14Gallery3 from '../assets/Car/Cars/Car-16.jpg';
import car14Gallery4 from '../assets/Car/Cars/Car-17.jpg';
import car14Review1 from '../assets/Car/Reviews/Pic-1.jpg';
import car14Review2 from '../assets/Car/Reviews/Pic-2.jpg';

import car15Gallery1 from '../assets/Car/Cars/Car-15.jpg';
import car15Gallery2 from '../assets/Car/Cars/Car-16.jpg';
import car15Gallery3 from '../assets/Car/Cars/Car-17.jpg';
import car15Gallery4 from '../assets/Car/Cars/Car-18.jpg';
import car15Review1 from '../assets/Car/Reviews/Pic-1.jpg';
import car15Review2 from '../assets/Car/Reviews/Pic-2.jpg';

import car16Gallery1 from '../assets/Car/Cars/Car-16.jpg';
import car16Gallery2 from '../assets/Car/Cars/Car-17.jpg';
import car16Gallery3 from '../assets/Car/Cars/Car-18.jpg';
import car16Gallery4 from '../assets/Car/Cars/Car-19.jpg';
import car16Review1 from '../assets/Car/Reviews/Pic-1.jpg';
import car16Review2 from '../assets/Car/Reviews/Pic-2.jpg';

import car17Gallery1 from '../assets/Car/Cars/Car-17.jpg';
import car17Gallery2 from '../assets/Car/Cars/Car-18.jpg';
import car17Gallery3 from '../assets/Car/Cars/Car-19.jpg';
import car17Gallery4 from '../assets/Car/Cars/Car-20.jpg';
import car17Review1 from '../assets/Car/Reviews/Pic-1.jpg';
import car17Review2 from '../assets/Car/Reviews/Pic-2.jpg';

import car18Gallery1 from '../assets/Car/Cars/Car-18.jpg';
import car18Gallery2 from '../assets/Car/Cars/Car-19.jpg';
import car18Gallery3 from '../assets/Car/Cars/Car-20.jpg';
import car18Gallery4 from '../assets/Car/Cars/Car-21.jpg';
import car18Review1 from '../assets/Car/Reviews/Pic-1.jpg';
import car18Review2 from '../assets/Car/Reviews/Pic-2.jpg';

import car19Gallery1 from '../assets/Car/Cars/Car-19.jpg';
import car19Gallery2 from '../assets/Car/Cars/Car-20.jpg';
import car19Gallery3 from '../assets/Car/Cars/Car-21.jpg';
import car19Gallery4 from '../assets/Car/Cars/Car-22.jpg';
import car19Review1 from '../assets/Car/Reviews/Pic-1.jpg';
import car19Review2 from '../assets/Car/Reviews/Pic-2.jpg';

import car20Gallery1 from '../assets/Car/Cars/Car-20.jpg';
import car20Gallery2 from '../assets/Car/Cars/Car-21.jpg';
import car20Gallery3 from '../assets/Car/Cars/Car-22.jpg';
import car20Gallery4 from '../assets/Car/Cars/Car-1.jpg';
import car20Review1 from '../assets/Car/Reviews/Pic-1.jpg';
import car20Review2 from '../assets/Car/Reviews/Pic-2.jpg';

import car21Gallery1 from '../assets/Car/Cars/Car-21.jpg';
import car21Gallery2 from '../assets/Car/Cars/Car-22.jpg';
import car21Gallery3 from '../assets/Car/Cars/Car-1.jpg';
import car21Gallery4 from '../assets/Car/Cars/Car-2.jpg';
import car21Review1 from '../assets/Car/Reviews/Pic-1.jpg';
import car21Review2 from '../assets/Car/Reviews/Pic-2.jpg';

import car22Gallery1 from '../assets/Car/Cars/Car-22.jpg';
import car22Gallery2 from '../assets/Car/Cars/Car-1.jpg';
import car22Gallery3 from '../assets/Car/Cars/Car-2.jpg';
import car22Gallery4 from '../assets/Car/Cars/Car-3.jpg';
import car22Review1 from '../assets/Car/Reviews/Pic-1.jpg';
import car22Review2 from '../assets/Car/Reviews/Pic-2.jpg';


/*Shop*/
import product1Gallery1 from '../assets/Shop/Products/1.jpg';
import product1Gallery2 from '../assets/Shop/Products/2.jpg';
import product1Gallery3 from '../assets/Shop/Products/3.jpg';
import product1Gallery4 from '../assets/Shop/Products/4.jpg';
import product1Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product1Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product2Gallery1 from '../assets/Shop/Products/2.jpg';
import product2Gallery2 from '../assets/Shop/Products/3.jpg';
import product2Gallery3 from '../assets/Shop/Products/4.jpg';
import product2Gallery4 from '../assets/Shop/Products/5.jpg';
import product2Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product2Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product3Gallery1 from '../assets/Shop/Products/3.jpg';
import product3Gallery2 from '../assets/Shop/Products/4.jpg';
import product3Gallery3 from '../assets/Shop/Products/5.jpg';
import product3Gallery4 from '../assets/Shop/Products/6.jpg';
import product3Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product3Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product4Gallery1 from '../assets/Shop/Products/4.jpg';
import product4Gallery2 from '../assets/Shop/Products/5.jpg';
import product4Gallery3 from '../assets/Shop/Products/6.jpg';
import product4Gallery4 from '../assets/Shop/Products/7.jpg';
import product4Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product4Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product5Gallery1 from '../assets/Shop/Products/5.jpg';
import product5Gallery2 from '../assets/Shop/Products/6.jpg';
import product5Gallery3 from '../assets/Shop/Products/7.jpg';
import product5Gallery4 from '../assets/Shop/Products/8.jpg';
import product5Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product5Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product6Gallery1 from '../assets/Shop/Products/6.jpg';
import product6Gallery2 from '../assets/Shop/Products/7.jpg';
import product6Gallery3 from '../assets/Shop/Products/8.jpg';
import product6Gallery4 from '../assets/Shop/Products/9.jpg';
import product6Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product6Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product7Gallery1 from '../assets/Shop/Products/7.jpg';
import product7Gallery2 from '../assets/Shop/Products/8.jpg';
import product7Gallery3 from '../assets/Shop/Products/9.jpg';
import product7Gallery4 from '../assets/Shop/Products/1.jpg';
import product7Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product7Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product8Gallery1 from '../assets/Shop/Products/8.jpg';
import product8Gallery2 from '../assets/Shop/Products/9.jpg';
import product8Gallery3 from '../assets/Shop/Products/1.jpg';
import product8Gallery4 from '../assets/Shop/Products/2.jpg';
import product8Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product8Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product9Gallery1 from '../assets/Shop/Products/9.jpg';
import product9Gallery2 from '../assets/Shop/Products/10.jpg';
import product9Gallery3 from '../assets/Shop/Products/11.jpg';
import product9Gallery4 from '../assets/Shop/Products/12.jpg';
import product9Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product9Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product10Gallery1 from '../assets/Shop/Products/10.jpg';
import product10Gallery2 from '../assets/Shop/Products/11.jpg';
import product10Gallery3 from '../assets/Shop/Products/12.jpg';
import product10Gallery4 from '../assets/Shop/Products/13.jpg';
import product10Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product10Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product11Gallery1 from '../assets/Shop/Products/11.jpg';
import product11Gallery2 from '../assets/Shop/Products/12.jpg';
import product11Gallery3 from '../assets/Shop/Products/13.jpg';
import product11Gallery4 from '../assets/Shop/Products/14.jpg';
import product11Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product11Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product12Gallery1 from '../assets/Shop/Products/12.jpg';
import product12Gallery2 from '../assets/Shop/Products/13.jpg';
import product12Gallery3 from '../assets/Shop/Products/14.jpg';
import product12Gallery4 from '../assets/Shop/Products/15.jpg';
import product12Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product12Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product13Gallery1 from '../assets/Shop/Products/13.jpg';
import product13Gallery2 from '../assets/Shop/Products/14.jpg';
import product13Gallery3 from '../assets/Shop/Products/15.jpg';
import product13Gallery4 from '../assets/Shop/Products/1.jpg';
import product13Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product13Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product14Gallery1 from '../assets/Shop/Products/14.jpg';
import product14Gallery2 from '../assets/Shop/Products/15.jpg';
import product14Gallery3 from '../assets/Shop/Products/1.jpg';
import product14Gallery4 from '../assets/Shop/Products/2.jpg';
import product14Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product14Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product15Gallery1 from '../assets/Shop/Products/15.jpg';
import product15Gallery2 from '../assets/Shop/Products/1.jpg';
import product15Gallery3 from '../assets/Shop/Products/2.jpg';
import product15Gallery4 from '../assets/Shop/Products/3.jpg';
import product15Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product15Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

const Images = {

    /*Global*/
    logo,

    /*Home*/
    home1,
    home2,
    home3,

    /*Partners*/
    partner1,
    partner2,
    partner3,
    partner4,
    partner5,
    partner6,

    /*About*/
    about,

    /*Testimonials*/
    testimonial1,
    testimonial2,
    testimonial3,
    testimonial4,

    /*Team*/
    team1,
    team2,
    team3,
    team4,

    /*FAQs*/
    FAQs,

    /*Service*/
    service1,
    service1Gallery1,
    service1Gallery2,

    service2,
    service2Gallery1,
    service2Gallery2,

    service3,
    service3Gallery1,
    service3Gallery2,

    service4,
    service4Gallery1,
    service4Gallery2,

    service5,
    service5Gallery1,
    service5Gallery2,

    service6,
    service6Gallery1,
    service6Gallery2,

    /*Gallery*/
    gallery1,
    gallery2,
    gallery3,
    gallery4,
    gallery5,
    gallery6,
    gallery7,
    gallery8,
    gallery9,
    gallery10,

    /*Portfolio*/
    portfolio1,
    portfolio1Gallery1,
    portfolio1Gallery2,
    portfolio1Gallery3,
    portfolio1Gallery4,
    portfolio1Gallery5,
    portfolio1Gallery6,

    portfolio2,
    portfolio2Gallery1,
    portfolio2Gallery2,
    portfolio2Gallery3,
    portfolio2Gallery4,
    portfolio2Gallery5,
    portfolio2Gallery6,

    portfolio3,
    portfolio3Gallery1,
    portfolio3Gallery2,
    portfolio3Gallery3,
    portfolio3Gallery4,
    portfolio3Gallery5,
    portfolio3Gallery6,

    portfolio4,
    portfolio4Gallery1,
    portfolio4Gallery2,
    portfolio4Gallery3,
    portfolio4Gallery4,
    portfolio4Gallery5,
    portfolio4Gallery6,

    portfolio5,
    portfolio5Gallery1,
    portfolio5Gallery2,
    portfolio5Gallery3,
    portfolio5Gallery4,
    portfolio5Gallery5,
    portfolio5Gallery6,

    portfolio6,
    portfolio6Gallery1,
    portfolio6Gallery2,
    portfolio6Gallery3,
    portfolio6Gallery4,
    portfolio6Gallery5,
    portfolio6Gallery6,

    /*Blogs*/
    blog1,
    blog1Gallery1,
    blog1Gallery2,
    blog1Comment1,
    blog1Comment2,
    blog1Comment3,

    blog2,
    blog2Gallery1,
    blog2Gallery2,
    blog2Comment1,
    blog2Comment2,
    blog2Comment3,

    blog3,
    blog3Gallery1,
    blog3Gallery2,
    blog3Comment1,
    blog3Comment2,
    blog3Comment3,

    blog4,
    blog4Gallery1,
    blog4Gallery2,
    blog4Comment1,
    blog4Comment2,
    blog4Comment3,

    blog5,
    blog5Gallery1,
    blog5Gallery2,
    blog5Comment1,
    blog5Comment2,
    blog5Comment3,

    blog6,
    blog6Gallery1,
    blog6Gallery2,
    blog6Comment1,
    blog6Comment2,
    blog6Comment3,

    blog7,
    blog7Gallery1,
    blog7Gallery2,
    blog7Comment1,
    blog7Comment2,
    blog7Comment3,

    blog8,
    blog8Gallery1,
    blog8Gallery2,
    blog8Comment1,
    blog8Comment2,
    blog8Comment3,

    blog9,
    blog9Gallery1,
    blog9Gallery2,
    blog9Comment1,
    blog9Comment2,
    blog9Comment3,

    blog10,
    blog10Gallery1,
    blog10Gallery2,
    blog10Comment1,
    blog10Comment2,
    blog10Comment3,

    /*Shop*/
    product1Gallery1,
    product1Gallery2,
    product1Gallery3, 
    product1Gallery4,
    product1Review1,
    product1Review2,

    product2Gallery1,
    product2Gallery2,
    product2Gallery3,
    product2Gallery4,
    product2Review1,
    product2Review2,

    product3Gallery1,
    product3Gallery2,
    product3Gallery3,
    product3Gallery4,
    product3Review1,
    product3Review2,

    product4Gallery1,
    product4Gallery2,
    product4Gallery3,
    product4Gallery4,
    product4Review1,
    product4Review2,

    product5Gallery1,
    product5Gallery2,
    product5Gallery3,
    product5Gallery4,
    product5Review1,
    product5Review2,

    product6Gallery1,
    product6Gallery2,
    product6Gallery3,
    product6Gallery4,
    product6Review1,
    product6Review2,

    product7Gallery1,
    product7Gallery2,
    product7Gallery3,
    product7Gallery4,
    product7Review1,
    product7Review2,

    product8Gallery1,
    product8Gallery2,
    product8Gallery3,
    product8Gallery4,
    product8Review1,
    product8Review2,

    product9Gallery1,
    product9Gallery2,
    product9Gallery3,
    product9Gallery4,
    product9Review1,
    product9Review2,

    product10Gallery1,
    product10Gallery2,
    product10Gallery3,
    product10Gallery4,
    product10Review1,
    product10Review2,

    product11Gallery1,
    product11Gallery2,
    product11Gallery3,
    product11Gallery4,
    product11Review1,
    product11Review2,

    product12Gallery1,
    product12Gallery2,
    product12Gallery3,
    product12Gallery4,
    product12Review1,
    product12Review2,

    product13Gallery1,
    product13Gallery2,
    product13Gallery3,
    product13Gallery4,
    product13Review1,
    product13Review2,

    product14Gallery1,
    product14Gallery2,
    product14Gallery3,
    product14Gallery4,
    product14Review1,
    product14Review2,

    product15Gallery1,
    product15Gallery2,
    product15Gallery3,
    product15Gallery4,
    product15Review1,
    product15Review2,

    /*Cars*/
    car1Gallery1,
    car1Gallery2,
    car1Gallery3,
    car1Gallery4,
    car1Review1,
    car1Review2,

    car2Gallery1,
    car2Gallery2,
    car2Gallery3,
    car2Gallery4,
    car2Review1,
    car2Review2,

    car3Gallery1,
    car3Gallery2,
    car3Gallery3,
    car3Gallery4,
    car3Review1,
    car3Review2,

    car4Gallery1,
    car4Gallery2,
    car4Gallery3,
    car4Gallery4,
    car4Review1,
    car4Review2,

    car5Gallery1,
    car5Gallery2,
    car5Gallery3,
    car5Gallery4,
    car5Review1,
    car5Review2,

    car6Gallery1,
    car6Gallery2,
    car6Gallery3,
    car6Gallery4,
    car6Review1,
    car6Review2,

    car7Gallery1,
    car7Gallery2,
    car7Gallery3,
    car7Gallery4,
    car7Review1,
    car7Review2,

    car8Gallery1,
    car8Gallery2,
    car8Gallery3,
    car8Gallery4,
    car8Review1,
    car8Review2,

    car9Gallery1,
    car9Gallery2,
    car9Gallery3,
    car9Gallery4,
    car9Review1,
    car9Review2,

    car10Gallery1,
    car10Gallery2,
    car10Gallery3,
    car10Gallery4,
    car10Review1,
    car10Review2,

    car11Gallery1,
    car11Gallery2,
    car11Gallery3,
    car11Gallery4,
    car11Review1,
    car11Review2,
    
    car12Gallery1,
    car12Gallery2,
    car12Gallery3,
    car12Gallery4,
    car12Review1,
    car12Review2,
    
    car13Gallery1,
    car13Gallery2,
    car13Gallery3,
    car13Gallery4,
    car13Review1,
    car13Review2,
    
    car14Gallery1,
    car14Gallery2,
    car14Gallery3,
    car14Gallery4,
    car14Review1,
    car14Review2,
    
    car15Gallery1,
    car15Gallery2,
    car15Gallery3,
    car15Gallery4,
    car15Review1,
    car15Review2,
    
    car16Gallery1,
    car16Gallery2,
    car16Gallery3,
    car16Gallery4,
    car16Review1,
    car16Review2,
    
    car17Gallery1,
    car17Gallery2,
    car17Gallery3,
    car17Gallery4,
    car17Review1,
    car17Review2,
    
    car18Gallery1,
    car18Gallery2,
    car18Gallery3,
    car18Gallery4,
    car18Review1,
    car18Review2,
    
    car19Gallery1,
    car19Gallery2,
    car19Gallery3,
    car19Gallery4,
    car19Review1,
    car19Review2,
    
    car20Gallery1,
    car20Gallery2,
    car20Gallery3,
    car20Gallery4,
    car20Review1,
    car20Review2,
    
    car21Gallery1,
    car21Gallery2,
    car21Gallery3,
    car21Gallery4,
    car21Review1,
    car21Review2,

    car22Gallery1,
    car22Gallery2,
    car22Gallery3,
    car22Gallery4,
    car22Review1,
    car22Review2,

};

export default Images;